/**
 * i18n configuration for Child App
 * Default language: Afrikaans (af)
 * Supported languages: Afrikaans (af), English (en)
 */

import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import af from './locales/af.json';
import en from './locales/en.json';

/**
 * Initialize i18next with Afrikaans as default
 */
export async function initI18n() {
  // Check if user has a language preference, if not set Afrikaans as default
  const savedLanguage = localStorage.getItem('i18nextLng');
  if (!savedLanguage) {
    localStorage.setItem('i18nextLng', 'af');
  }

  await i18next
    .use(LanguageDetector)
    .init({
      fallbackLng: 'af',
      defaultNS: 'common',
      debug: import.meta.env.DEV,
      resources: {
        af: {
          common: af
        },
        en: {
          common: en
        }
      },
      detection: {
        order: ['localStorage'],
        caches: ['localStorage']
      }
    });

  console.log('Child App i18n initialized with language:', i18next.language);
  return i18next;
}

/**
 * Get translated text
 */
export function t(key, options) {
  return i18next.t(key, options);
}

/**
 * Change language
 */
export function changeLanguage(lang) {
  return i18next.changeLanguage(lang);
}

/**
 * Get current language
 */
export function getCurrentLanguage() {
  return i18next.language || 'af';
}